<template>
	<div class="modal-footer" v-if="options.showFooter">
		<div class="modal-footer-left-item">

		</div>
		<div class="modal-footer-center-item">
			<component :is="options.component" v-if="options.component"/>
			<BaseButton :title="options.confirmTitle"
				:classNames="['button--modifier']"
				:ariaLabel="options.confirmTitle"
				@click.native="confirmationPressed" />
		</div>
		<div class="modal-footer-right-item">

		</div>
	</div>
</template>

<script>
	export default {
		props: {
			options: {
				type: Object,
				default: null,
			},
		},
		methods: {
			confirmationPressed() {
				let result = true;
				if (this.options.confirmAction) {
					result = this.options.confirmAction();
				}
				if (result === null) { return; }
				this.$modal.hide('contentModal');
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.modal-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;

		padding: 1rem;

		border-top: 1px solid $greyOutline;
	}
	@include desktop {
		// TODO replace color with configuration for modal footer
		background-color: $checkoutBackgroundColor;
	}
	@include mobile {
		.modal-footer {
			position: fixed;
			bottom: 0;

			width: 100vw;
			background: white;
			z-index: $zModalTopLayer;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/global-modal/ContentModalFooter.vue